exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.currencyImg[data-v-2d7832b4] {\n    vertical-align: middle;\n    width: 20px;\n}\n", ""]);
